var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalAction
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "common-info-modal",
            title: _vm.modalAction.Title,
            size: "xl",
            "no-close-on-backdrop": "",
            "hide-footer": ""
          },
          on: { show: _vm.show }
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.commonInfo.createdUser"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.CreatedUser,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CreatedUser", $$v)
                          },
                          expression: "form.CreatedUser"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.commonInfo.createdDateTime"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.CreatedDateTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CreatedDateTime", $$v)
                          },
                          expression: "form.CreatedDateTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.commonInfo.modifiedUser"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.ModifiedUser,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ModifiedUser", $$v)
                          },
                          expression: "form.ModifiedUser"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.commonInfo.modifiedDateTime"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.ModifiedDateTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ModifiedDateTime", $$v)
                          },
                          expression: "form.ModifiedDateTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-table", {
                        attrs: {
                          id: "info-list",
                          items: _vm.form.UpdateLogs,
                          fields: _vm.infoFields,
                          striped: "",
                          responsive: "",
                          "current-page": _vm.mainCurrentPage,
                          "per-page": 10
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head()",
                              fn: function(data) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t(data.label)) +
                                      "\n          "
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(UpdateSummary)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "summary-span",
                                      attrs: { title: row.item.UpdateSummary }
                                    },
                                    [_vm._v(_vm._s(row.item.UpdateSummary))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-link",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle",
                                          value: "header-collapse-" + row.index,
                                          expression:
                                            "`header-collapse-${row.index}`"
                                        }
                                      ],
                                      staticClass: "detail-button",
                                      attrs: { variant: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getFirstDetail(row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("insert.commonInfo.detail")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-collapse",
                                    {
                                      staticClass: "mt-2",
                                      attrs: {
                                        id: "header-collapse-" + row.index
                                      }
                                    },
                                    [
                                      _c(
                                        "b-table",
                                        {
                                          staticClass: "small-detail",
                                          attrs: {
                                            items: row.item.HeaderList,
                                            fields: _vm.firstDetailHeaderFields,
                                            bordered: "",
                                            responsive: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "head()",
                                                fn: function(data) {
                                                  return [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(data.label)
                                                        ) +
                                                        "\n              "
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n              >\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(show_details)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          staticClass: "detail-button",
                                          attrs: { variant: "success" },
                                          on: {
                                            click: function($event) {
                                              _vm.getFirstDetail(row)
                                              row.toggleDetails()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.commonInfo.detail"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "row-details",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "p-4 mt-2 nested-detail-panel"
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-table",
                                                {
                                                  attrs: {
                                                    items: row.item.DetailList,
                                                    fields: _vm.infoFields,
                                                    bordered: "",
                                                    responsive: ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "head()",
                                                        fn: function(data) {
                                                          return [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    data.label
                                                                  )
                                                                ) +
                                                                "\n                   "
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key:
                                                          "cell(show_details)",
                                                        fn: function(
                                                          detailRow
                                                        ) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "b-link",
                                                                  {
                                                                    staticClass:
                                                                      "detail-button",
                                                                    attrs: {
                                                                      variant:
                                                                        "success"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.getSecondDetail(
                                                                          detailRow,
                                                                          row.index
                                                                        )
                                                                        detailRow.toggleDetails()
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                         " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "insert.commonInfo.detail"
                                                                          )
                                                                        ) +
                                                                        "\n                       "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "row-details",
                                                        fn: function(row) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "p-4 mt-2 nested-detail-panel-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-row",
                                                                  [
                                                                    _c(
                                                                      "b-col",
                                                                      [
                                                                        _c(
                                                                          "b-table",
                                                                          {
                                                                            attrs: {
                                                                              items:
                                                                                row
                                                                                  .item
                                                                                  .DetailList,
                                                                              fields:
                                                                                _vm.firstDetailHeaderFields,
                                                                              striped:
                                                                                "",
                                                                              responsive:
                                                                                ""
                                                                            },
                                                                            scopedSlots: _vm._u(
                                                                              [
                                                                                {
                                                                                  key:
                                                                                    "head()",
                                                                                  fn: function(
                                                                                    data
                                                                                  ) {
                                                                                    return [
                                                                                      _vm._v(
                                                                                        "\n                              " +
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              data.label
                                                                                            )
                                                                                          ) +
                                                                                          "\n                            "
                                                                                      )
                                                                                    ]
                                                                                  }
                                                                                }
                                                                              ],
                                                                              null,
                                                                              true
                                                                            )
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                           >\n                           "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                 >\n                   "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2242279018
                        )
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.form.UpdateLogs
                            ? _vm.form.UpdateLogs.length
                            : 0,
                          "per-page": 10,
                          "aria-controls": "info-list"
                        },
                        model: {
                          value: _vm.mainCurrentPage,
                          callback: function($$v) {
                            _vm.mainCurrentPage = $$v
                          },
                          expression: "mainCurrentPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "asc__modal-approveModal-footer",
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "w-100 text-right" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "button",
                                variant: "danger",
                                size: "md"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closeModal()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("index.close")) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4653b67c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4653b67c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/CommonInfoModal.vue
// module id = null
// module chunks = 